import { Stack, type StackProps, Typography, useTheme } from "@mui/material";
import {
	RowSkeletonLoader,
	type RowSkeletonLoaderSize,
} from "web_myplann/Shared/RowSkeletonLoader";

type Props = {
	label: string;
	description: string;
	skeletonSize?: RowSkeletonLoaderSize;
} & StackProps;

export const EmptyListSkeleton = ({
	label,
	description,
	skeletonSize,
	...props
}: Props) => {
	const theme = useTheme();

	return (
		<Stack
			height="85vh"
			justifyContent="center"
			alignItems="center"
			padding="0 64px"
			{...props}
		>
			<Stack gap={1.6}>
				<RowSkeletonLoader disableAnimation size={skeletonSize} />
				<RowSkeletonLoader disableAnimation size={skeletonSize} />
				<RowSkeletonLoader disableAnimation size={skeletonSize} />
			</Stack>
			<Stack pt={2.4} textAlign={"center"}>
				<Typography
					variant="deprecatedH3"
					color={theme.palette.deprecated.grey[700]}
				>
					{label}
				</Typography>
				<Typography
					variant="deprecatedCaption"
					color={theme.palette.deprecated.grey[500]}
					align="center"
				>
					{description}
				</Typography>
			</Stack>
		</Stack>
	);
};
